import * as React from 'react';
import { core_apimessages_CreditCard as CreditCard } from '../schemas/rql';
import * as I18n from 'i18n-js';
import CreditCardIcon from '../credit_cards/legacy/credit_card_icon';
import TokenizedField from '../credit_cards/tokenized_field';
import FormGroup from '@reverbdotcom/commons/dist/components/form_group';

export interface Props {
  creditCard: CreditCard;
  onSelect(id: string): void;
  selected: boolean;
  hasFocus: boolean;
  error: string;
}

export default function GiftCardCreditCardListItem(props: Props) {
  function onCreditCardSelect() {
    props.onSelect(props.creditCard.id);
  }

  const cardAbout = `${props.creditCard.cardType} ....${props.creditCard.last4}`;
  const expiryDate = `${props.creditCard.expirationMonth}/${props.creditCard.expirationYear}`;
  const inputId = `credit_card_${props.creditCard.id}`;

  return (
    <li
      className="shop-onboarding__card"
      onClick={onCreditCardSelect}
    >
      <input
        className="boxed-list__toggle"
        type="radio"
        checked={props.selected}
        id={inputId}
        name="gift_card_form[credit_card_id]"
        value={props.creditCard.id}
        readOnly
      />
      <label
        className="boxed-list__item boxed-list__item--selectable"
        htmlFor={inputId}
      >
        <div className="cc-details">
          <div className="cc-details__card">
            <div className="cc-details__icon">
              <CreditCardIcon
                cardType={props.creditCard.cardType}
              />
            </div>
            <div className="cc-details__card-info">
              <div className="cc-details__card-type">
                {cardAbout}
              </div>
              <div className="cc-details__expiration">
                {I18n.t('discovery.selectableCreditCardList.expiresOn', { date: expiryDate })}
              </div>
            </div>
          </div>
        </div>
        {props.selected &&
          <div className="mt-space">
            <FormGroup
              data-credit-card-cvv
              label={I18n.t('discovery.creditCardForm.cvv')}
              errorText={props.error}
            >
              <TokenizedField fieldName="encryptedSecurityCode" hasError={!!props.error} hasFocus={props.hasFocus} />
            </FormGroup>
          </div>
        }
      </label>
    </li>
  );
}



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/components/gift_card_credit_card_list_item.tsx